import { render, staticRenderFns } from "./SiteLabel.vue?vue&type=template&id=4d0a4893&scoped=true"
import script from "./SiteLabel.vue?vue&type=script&lang=js"
export * from "./SiteLabel.vue?vue&type=script&lang=js"
import style0 from "./SiteLabel.vue?vue&type=style&index=0&id=4d0a4893&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d0a4893",
  null
  
)

export default component.exports